import { render } from "./CardsCarousel.vue?vue&type=template&id=2c2b947c&scoped=true&ts=true"
import script from "./CardsCarousel.vue?vue&type=script&lang=ts"
export * from "./CardsCarousel.vue?vue&type=script&lang=ts"

import "./CardsCarousel.vue?vue&type=style&index=0&id=2c2b947c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2b947c"]])

export default __exports__